export const REQUEST_PAID_EVENT_STREAMS = 'REQUEST_PAID_EVENT_STREAMS'
export const RECEIVE_PAID_EVENT_STREAMS = 'RECEIVE_PAID_EVENT_STREAMS'

const requestPaidEventsStreams = () => ({
  type: REQUEST_PAID_EVENT_STREAMS
})

const receivePaidEventsStreams = streams => ({
  type: RECEIVE_PAID_EVENT_STREAMS,
  streams
})

export const fetchPaidEventsSterams = personId => dispatch => {
  dispatch(requestPaidEventsStreams())

  return fetch(process.env.REACT_APP_BASE_URL + '/chargedevents/get_charged_events',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=utf-8'
      },
      body: JSON.stringify({ personId })
    })
    .then(
      response => response.json(),
      error => console.log('An error occurred', error)
    )
    .then(json => dispatch(receivePaidEventsStreams(json)))
}
